const claimStatus = {
  OPEN: 0,
  WAITING_RESOLUTION: 1,
  CONFIRMED: 2,
  CANCELLED: 3,
  CONCLUDED: 4
};

module.exports = claimStatus;
